import styled from "styled-components";

import { useT } from "./i18n";

// Two visual families so physical vs booking status are never confused:
//   variant="soft"    -> pale filled chip (physical room status): meta.bg / meta.fg / meta.border
//   variant="outline" -> white pill, colored text + border (booking / date status): meta.color
const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: ${(props) => (props.$block ? "0.32rem 0.6rem" : "0.2rem 0.5rem")};
  width: ${(props) => (props.$block ? "100%" : "auto")};
  justify-content: ${(props) => (props.$block ? "center" : "flex-start")};
  border-radius: ${(props) => (props.$variant === "outline" ? "999px" : "8px")};
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
  color: ${(props) => props.$fg};
  background: ${(props) => props.$bg};
  border: 1px solid ${(props) => props.$border};
`;

const resolve = (meta, variant) => {
  // A `solid` meta (e.g. blocked) always wins: solid fill + white text, regardless of variant.
  if (meta.solid) {
    return { bg: meta.solid, fg: "#ffffff", border: meta.solid };
  }
  if (variant === "outline") {
    return { bg: "#ffffff", fg: meta.color, border: meta.color };
  }
  return { bg: meta.bg, fg: meta.fg, border: meta.border };
};

const StatusBadge = (props) => {
  const { t } = useT();
  const meta = props.meta;
  if (!meta) {
    return null;
  }
  const Icon = meta.Icon;
  const variant = props.variant || "soft";
  const size = props.size || 14;
  const colors = resolve(meta, variant);
  return (
    <Pill
      $variant={variant}
      $bg={colors.bg}
      $fg={colors.fg}
      $border={colors.border}
      $block={props.block}
      title={t(meta.labelKey)}
    >
      <Icon size={size} aria-hidden="true" />
      {t(meta.labelKey)}
      {meta.suffix || ""}
    </Pill>
  );
};

export default StatusBadge;
